import { render, staticRenderFns } from "./ButtonAddFileByGroup.vue?vue&type=template&id=7a6928e1"
import script from "./ButtonAddFileByGroup.vue?vue&type=script&lang=js"
export * from "./ButtonAddFileByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports